/**
 * Memoizes a function to cache its results based on input arguments.
 * Improves performance by avoiding recalculation for the same inputs.
 */
export function memoize<T, R>(fn: (...args: T[]) => R): (...args: T[]) => R {
  const cache = new Map<string, R>();
  
  return (...args: T[]): R => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key)!;
    }
    
    const result = fn(...args);
    cache.set(key, result);
    return result;
  };
}
